export default {
  'primary': '#102B4E',
  'secondary': '#F58112',
  'accent': '#002e69'
}
